import { useMemo } from "preact/hooks";
import { useEdition } from "./useEdition";
import { getTranslations, type TranslationKey } from "../lib/i18n";

export function useTranslations() {
  const { locale } = useEdition();

  return useMemo(() => getTranslations(locale), [locale]);
}

export function useT() {
  const t = useTranslations();
  return (key: TranslationKey) => t[key];
}
